<dx-box width="100%" height="100%" direction="col">
    <dxi-item baseSize="auto">
        <h2 class="page-header" [ngClass]="{ 'cc-text-center': isSmallScreen }">
            {{ pageTitle }}
            <sup *ngIf="helpLink" class="page-help-icon">
                <a [href]="helpLink" target="_blank" class="fas fa-question-circle"></a>
            </sup>
        </h2>
    </dxi-item>
    <dxi-item [ratio]="1" class="cc-white-background user-portfolio-container">
        <router-outlet (activate)="onRouteActivate($event)"></router-outlet>
    </dxi-item>
</dx-box>

<dx-load-panel *ngIf="loadingVisible" [position]="{ of: 'body' }" [visible]="loadingVisible"></dx-load-panel>
